<main @fade *ngIf="permissionDenied===false">
  <nb-card [nbSpinner]="loading">
    <nb-card-header *ngIf="!isModal && editMode === false" i18n="@@Creating">
      <a [routerLink]="absolutePath">{{ title }}</a> / Добавление
    </nb-card-header>
    <nb-card-header *ngIf="!isModal && editMode === true" i18n="@@Updating">

      <app-breadcrumbs controller="/cabinet/dam" param="catalog_id" [breadCrumbs]="catalogBreadCrumbs"></app-breadcrumbs>
      <h4 *ngIf="editMode">{{ model?.header }}</h4>
    </nb-card-header>

    <nb-card-header *ngIf="deleted"><span i18n="@@RecordDeletedNoTags" class="badge text-bg-secondary">запись удалена</span>
      &nbsp;
      <button *ngIf="deleted" (click)="restore()" i18n-nbTooltip="@@Restore" nbTooltip="Восстановить" nbButton status="control" size="small">
        <nb-icon icon="repeat-outline"></nb-icon>
      </button>
    </nb-card-header>

    <nb-card-body>
      <!--        <button class="btn-brand">-->
      <!--          Сохранить изменения-->
      <!--        </button>-->
      <!--      </div>-->
      <nb-tabset class="dam-tabset" (changeTab)="getTab($event)" #tabset>
        <nb-tab class="info-tab" i18n-tabTitle="@@Info" [tabId]="tabsIDs.info" tabTitle="Информация" route="#info" [tabIndex]="0">
          <div class="grid">
            <div class="grid-left">
              <ng-container *ngIf="editMode === true && model">
                <app-dam-item-info-view [model]="model" [write]="write" [damItem]="currentDamVersion" (change)="loadDamItemVersions()"/>
              </ng-container>
              <div class="item-params">
                <app-terms *ngIf="editMode === true && write" (removeTermEvent)="removeTerm($event)" (insertTermEvent)="insertTerm($event)" [model]="model"></app-terms>
                <app-dam-item-params [hidden]="!write" [form]="form" [fields]="fields" [options]="options" [model]="model" (submitEvent)="onSubmit()" [absolutePath]="absolutePath" [isModal]="isModal" [showListButton]="showListButton"/>
              </div>

            </div>
            <app-dam-item-versions [modelId]="id" [write]="write" (versionSelectEvent)="onVersionSelect($event)" [damItemVersions]="damItemVersions" [currentVersion]="currentDamVersion" [fileExtensions]="fileExtensions"></app-dam-item-versions>
          </div>

        </nb-tab>
        <nb-tab class="characteristics-tab" *ngIf="editMode && model && write" [nbSpinner]="featureTabSpinner" i18n-tabTitle="@@Features" tabTitle="Свойства" [tabId]="tabsIDs.features" #featureTab badgeStatus="success" route="#feature" [tabIndex]="1">
          <app-template-features *ngIf="editMode && model" [model]="model" (featureUnsavedChangesEvent)="onFeatureModelChanges($event)" (closeModalEvent)="modalClose()" (backEvent)="back()"/>
        </nb-tab>
        <nb-tab class="access-rights-tab" i18n-tabTitle="@@Permissions" [tabId]="tabsIDs.permissions" tabTitle="Доступы" *ngIf="administration" [tabIndex]="2">
          <ng-container *ngIf="permissionDenied ===false && editMode === true && model?.id!=null && permissions!=null">
            <app-permissions [modelId]="model.id" [permissions]="permissions"></app-permissions>
          </ng-container>
        </nb-tab>

        <nb-tab i18n-tabTitle="@@attachedElements" #attachedElementsTab [tabId]="tabsIDs.attachedElements" tabTitle="Связанные элементы" *ngIf="administration" [tabIndex]="3">
          <ng-container *ngIf="editMode && model && damRelatedCollection?.length">
            <app-attached-elements [damElements]="" [damRelatedCollection]="damRelatedCollection" [model]="model" [uri]="uri"></app-attached-elements>
          </ng-container>
        </nb-tab>
<!--        <nb-tab-->
<!--          i18n-tabTitle="@@changeHistory"-->
<!--          #changeHistory-->
<!--          [tabId]="tabsIDs.changeHistory"-->
<!--          tabTitle="История изменений"-->
<!--          *ngIf="this.administration"-->
<!--          [tabIndex]="4"-->
<!--        >-->
<!--          <ng-container *ngIf="editMode && model && damRelatedCollection?.length">-->
<!--            <app-file-change-history [model]="model">-->
<!--            </app-file-change-history>-->
<!--          </ng-container>-->
<!--        </nb-tab>-->
      </nb-tabset>


    </nb-card-body>
  </nb-card>
</main>
<main *ngIf="editMode === true && permissionDenied" style="padding: 20px;">
  <div class="col-lg-4">
    Permission Denied
  </div>
</main>
